module.exports = "/images/checkbox-pink.svg?14f748036f1487f729a660ba691061fe";